// RECAPTCHA Actions
export const ENROLL_RECAPTCHA_ACTION_KEY = "ENROLLMENT";
export const REGISTER_RECAPTCHA_ACTION_KEY = "REGISTER";
